import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { SpaceAddReservationComponent } from "./space-add-reservation.component";
import { TranslateModule } from "@ngx-translate/core";
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from "@danielmoncada/angular-datetime-picker";
import { PaginationClientSideModule } from "src/app/app/_component/pagination-client-side/pagination-client-side.module";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { SelectUserModule } from "src/app/app/_component/select-user/select-user.module";
import { MatRadioModule } from "@angular/material/radio";
import { SpaceDateFilterComponentModule } from "src/app/app/_component/_space/space-date-filter/space-date-filter.module";
import { BreadcrumbComponentModule } from "../../breadcrumb/breadcrumb.module";
import { SelectButtonsModule } from "../../select-buttons/select-buttons.module";
import { SpaceMapComponentModule } from "../space-map/space-map.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    PaginationClientSideModule,
    SharedDirectivesModule,
    LoadingStiModule,
    SelectUserModule,
    MatRadioModule,
    SpaceDateFilterComponentModule,
    BreadcrumbComponentModule,
    SelectButtonsModule,
    SpaceMapComponentModule,
  ],
  declarations: [SpaceAddReservationComponent],
  exports: [SpaceAddReservationComponent],
})
export class SpaceAddReservationComponentModule {}
